import dayjs from 'dayjs';
import LocalStorage from '@/helpers/localStorage';

const CalendarSelectableStore = {
  period: {},
  datepicked: [],
  getType: () => (LocalStorage.get('calendar_type') ? JSON.parse(LocalStorage.get('calendar_type')) : null),
  getPeriodInit: (spaceRef) => (LocalStorage.get(`calendar_period${spaceRef}`) ? JSON.parse(LocalStorage.get(`calendar_period${spaceRef}`)) : {}),
  getDatesPickedInit: (spaceRef) => (LocalStorage.get(`calendar_datespicked${spaceRef}`) ? JSON.parse(LocalStorage.get(`calendar_datespicked${spaceRef}`)) : []),
  setType: (value) => (value ? LocalStorage.set('calendar_type', JSON.stringify(value)) : LocalStorage.remove('calendar_type')),
  setPeriod(value) {
    this.period = value;
    return this;
  },
  setDatesPicked(value) {
    this.datepicked = value;
    return this;
  },
  getPeriod() { return this.period || {}; },
  getDatesPicked() { return this.datepicked || []; },

  init(spaceRef) {
    const initPeriod = this.getPeriodInit(spaceRef);
    const initDatesPicked = this.getDatesPickedInit(spaceRef);
    this.setPeriod(initPeriod);
    this.setDatesPicked(initDatesPicked);
    this.reset(spaceRef);
  },

  reset: (spaceRef) => {
    LocalStorage.remove(`calendar_period${spaceRef}`);
    LocalStorage.remove(`calendar_datespicked${spaceRef}`);
  },
  guessPeriod(date, data) {
    if (data && data.category === 'disableByHostFromSpaceDisponibility') {
      const type = { 1: 'morning', 2: 'afternoon', 3: 'night' };
      if (type[data.period]) return type[data.period];
      return 'allday';
    }
    if (date) {
      switch (this.getPeriod() && this.getPeriod()[date.formatAsKey()]) {
        case 1:
          if (this.getType() === 'halfday') {
            return 'morning';
          }
          break;
        case 2:
          if (this.getType() === 'halfday') {
            return 'afternoon';
          }
          break;
        case 3:
          return 'night';
        default:
          return 'allday';
      }
    }
    return false;
  },
  countTotalDays() {
    let count = 0;
    const p = this.getPeriod();
    Object.entries(p).forEach(([, pd]) => {
      if (this.getType() === 'allday') {
        count += 1;
      } else {
        switch (pd) {
          case 1:
          case 2:
            count += 0.5;
            break;
          default:
            count += 1;
        }
      }
    });

    return count;
  },
  setTypeFromSpace(space, category) {
    this.setType('allday');
    if (space[category] && space[category].allow_halfday) {
      this.setType('halfday');
    }
  },
  setTypeFromCategory() {
    this.setType('halfday');
  },
  getDaysInMonth2(month, year) {
    let start = dayjs().year(year).month(month).startOf('month');

    let end = dayjs(start).endOf('month');
    // on se met à lundi suivant le premier jour du mois
    let nextMonday = (parseInt(start.format('d'), 10) ? (7 - parseInt(start.format('d'), 10)) : 0) + 1;

    // puis on se met à last lundi pour avoir une ligne calendar qui comprend le debut du mois
    start = start.add(nextMonday, 'day').subtract(7, 'day');

    // on se met au dernier dimanche du mois
    nextMonday = (7 - parseInt(end.format('d'), 10));
    end = end.add(nextMonday, 'day');
    return [start, end];
  },
  getDaysInMonth(month, year) {
    const result = this.getDaysInMonth2(month, year);
    let date = result[0];
    const max = result[1];
    const days = [];
    // on parcours jusquà la fin entre start et end
    let i = 0;
    // eslint-disable-next-line no-plusplus
    while (date.diff(max) <= 0 && i++ < 50) {
      let active = true;
      if (date.month() !== month) {
        active = false;
      }
      const newDate = dayjs(date).startOf('day');
      const day = {
        date: newDate,
        active,
      };
      days.push(day);
      date = date.add(1, 'day');
    }
    return days;
  },
  isPast(date) {
    let today = dayjs();
    today = today.startOf('day');
    let o = dayjs(date);
    if (typeof date === 'string' || date instanceof String) {
      o = dayjs(date);
    }
    o = o.startOf('day');
    return (o.diff(today) < 0);
  },
};

export default CalendarSelectableStore;
